type LogLevel = 'log' | 'warn' | 'error' | 'info' | 'debug';

const isDev = process.env.NODE_ENV === 'development';

/**
 * Creates a logger instance with a custom prefix.
 * Logs are only displayed in development mode.
 *
 * @example
 * const authLogger = createLogger('AUTH');
 * authLogger.log('User logged in'); // [AUTH] User logged in
 */
export const createLogger = (prefix: string) => {
  const log = (level: LogLevel, ...args: unknown[]) => {
    if (isDev) {
      console[level](`[${prefix}]`, ...args);
    }
  };

  return {
    log: (...args: unknown[]) => log('log', ...args),
    warn: (...args: unknown[]) => log('warn', ...args),
    error: (...args: unknown[]) => log('error', ...args),
    info: (...args: unknown[]) => log('info', ...args),
    debug: (...args: unknown[]) => log('debug', ...args),
  };
};

/**
 * Default application logger.
 * Use this for general logging, or create a custom logger with createLogger().
 *
 * @example
 * import { logger } from 'utils/logger';
 * logger.log('Something happened'); // [APP] Something happened
 */
export const logger = createLogger('APP');
